import { render, staticRenderFns } from "./EditMenu.vue?vue&type=template&id=01c68d4a&"
import script from "./EditMenu.vue?vue&type=script&lang=js&"
export * from "./EditMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports